export const timeline = [
  {
    year : 2021,
    elements : [
      {
        head : "Joined Credflow as a software developer intern",
        para : "Contributed to core Credflow products implementing features including Link tracking and User invite system, developing and refactoring 20+ custom REST APIs, optimizing code performance, and developing internal npm packages and microservices."
      }
    ]
  },
  {
    year : 2020,
    elements : [
      {
        head : "Got another internship offer at Axtrion Digital",
        para : "Developed a web application using React to capture user video and audio feed using MediaStream API of the browser."
      },
      {
        head : "Got my first Internship offer at Dakshas Healthcare NGO 🔥",
        para : "Developed an application in React to help healthcare organization to properly manage their inventory. Learned a lot about React in this internship."
      },
      {
        head : "Got a silver medal in a football competition 🥈",
        para : "I always liked playing football and I also discovered other sports in the meantime."
      }
    ]
  },
  {
    year : 2019,
    elements : [
      {
        head : "Joined the Spring Fest web team of IITKGP",
        para : "Responsible for developing and managing the official websites of Spring Fest, IIT Kharagpur as a part of an 11-member team."
      },
      {
        head : "was appointed a member of the mess committee in IITKGP",
        para : "Oversaw the normal functioning of mess and other in-hall cafeterias and managed various activities of the mess."
      },
    ]
  },
  {
    year : 2018,
    elements : [
      {
        head : "Formed the RP Hall Web team IITKGP 👪",
        para : "Developed a fully dynamic website that manages the user data of over 1000 students and is used by both students and administrators for easier workflows."
      },
      {
        head : "Taught myself Javascript and C++ 👨🏻‍💻",
        para : "I wanted to learn how to code and learning Javascript and C++ was the first step that I took."
      },
      {
        head : "Started my B.Tech at Indian Institute of Technology Kharagpur 🎓",
        para : "Started studying engineering at one of the best universities of the country."
      }
    ]
  }
]